// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"d93838d7","453":"d9355f72"}[chunkId] + ".chunk.js";
};